import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children, roles }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    let redirectPath = '/parent';
    if (user?.role === 'admin' || user?.role === 'super_admin') {
      redirectPath = '/admin';
    } else if (user?.role === 'instructor' || user?.role === 'volunteer') {
      redirectPath = '/instructor';
    } else if (user?.role === 'partner') {
      redirectPath = '/partner';
    }
    return <Navigate to={redirectPath} replace />;
  }

  return children;
}
